import { useConnector } from 'react-instantsearch-hooks-web';
import connectRange from 'instantsearch.js/es/connectors/range/connectRange';

export function useRangeSlider( props ) {
	return useConnector( connectRange, props );
}

